import { useEffect, useState } from 'react'
import { breakpoints } from 'ui/styles/breakpoints'

export const useMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoints.desktop)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < breakpoints.desktop)
        }

        window.addEventListener('resize', checkMobile)
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    return isMobile
}
